import { render, staticRenderFns } from "./RevenuePerMonthTotal.vue?vue&type=template&id=ecb41ca0"
import script from "./RevenuePerMonthTotal.vue?vue&type=script&lang=ts"
export * from "./RevenuePerMonthTotal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecb41ca0')) {
      api.createRecord('ecb41ca0', component.options)
    } else {
      api.reload('ecb41ca0', component.options)
    }
    module.hot.accept("./RevenuePerMonthTotal.vue?vue&type=template&id=ecb41ca0", function () {
      api.rerender('ecb41ca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/RevenuePerMonthTotal.vue"
export default component.exports